import React from 'react';
import { DollarSign } from 'lucide-react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-navy-950 pt-16 pb-8 border-t border-gray-800">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
          <div>
            <div className="flex items-center mb-4">
              <div className="text-gold-500 mr-2">
                <DollarSign size={28} />
              </div>
              <span className="text-white text-xl font-bold">AAbA Stable</span>
            </div>
            <p className="text-gray-400 mb-6">
              Premium stable yield solution for investors seeking predictable returns from digital assets.
            </p>
          </div>
          
          <div className="grid grid-cols-2">
            <div>
              <h3 className="text-white font-semibold mb-4">Products</h3>
              <ul className="space-y-2">
                <li>
                  <a href="#" className="text-gray-400 hover:text-gold-500 transition-colors">AAbA Stable</a>
                </li>
                <li>
                  <a href="#contact" className="text-gray-400 hover:text-gold-500 transition-colors">AAbA Personal (contact us)</a>
                </li>
              </ul>
            </div>
            
            <div>
              <h3 className="text-white font-semibold mb-4">Company</h3>
              <ul className="space-y-2">
                <li>
                  <a href="#contact" className="text-gray-400 hover:text-gold-500 transition-colors">Contact</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-800 pt-8 mt-8">
          <div className="flex flex-col md:flex-row justify-center items-center">
            <p className="text-gray-500 text-sm">
              &copy; {new Date().getFullYear()} AAbA Stable. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;